import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Link } from '@ui/app-router';
import { useAuthnProvider } from '@ui/auth';
import { STORAGE_KEYS, links } from '@ui/constants';
import { DiscordIcon } from '@ui/custom-icons';
import { Button } from '@ui/primitives/button';
import { Separator } from '@ui/primitives/separator';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@ui/primitives/sheet';
import { RouteNames, authenticated_user_profile_path, organization_managed_applications_path, organization_projects_path, useTypedParams } from '@ui/routes';
import { useCurrentUser } from '@ui/user-context';
import { FileText, Folder, LogOut, Mail, Menu, Package, Search, Settings, User } from 'lucide-react';
import { NavLink } from '../../components/nav-link';
export function MobileMenu(param) {
    let { isOpen, onOpenChange, navigationItems, onSearchClick } = param;
    const { organization } = useTypedParams();
    const { user: userApi } = useCurrentUser();
    const { logout } = useAuthnProvider();
    const handleLogout = async ()=>{
        try {
            if (typeof window !== 'undefined') {
                localStorage.removeItem(STORAGE_KEYS.LAST_VISITED_ORG);
            }
        } catch (error) {
            //eslint-disable-next-line no-console
            console.error('Error clearing localStorage:', error);
        }
        await logout();
    };
    const userMenuItems = [
        {
            label: 'My Profile',
            icon: User,
            href: authenticated_user_profile_path()
        },
        ...organization ? [
            {
                label: 'Your Projects',
                icon: Folder,
                href: organization_projects_path({
                    organization: {
                        name: organization
                    }
                })
            },
            {
                label: 'Your Applications',
                icon: Package,
                href: organization_managed_applications_path({
                    organization: {
                        name: organization
                    }
                })
            }
        ] : [],
        {
            label: 'Your Organizations',
            icon: Settings,
            href: RouteNames.PERSONAL_DASHBOARD
        }
    ];
    return /*#__PURE__*/ _jsx(Sheet, {
        open: isOpen,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ _jsxs(SheetContent, {
            side: "left",
            className: "w-80 p-0 flex flex-col",
            children: [
                /*#__PURE__*/ _jsx(SheetHeader, {
                    className: "px-4 pt-6 pb-4",
                    children: /*#__PURE__*/ _jsx(SheetTitle, {
                        children: "Menu"
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex-1 overflow-y-auto",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "px-4 pb-4",
                            children: /*#__PURE__*/ _jsxs(Button, {
                                variant: "outline",
                                className: "w-full justify-start gap-2",
                                onClick: ()=>{
                                    onSearchClick();
                                    onOpenChange(false);
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(Search, {
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: "Search..."
                                    }),
                                    /*#__PURE__*/ _jsxs("kbd", {
                                        className: "ml-auto text-muted-foreground pointer-events-none h-5 select-none items-center gap-1 rounded-sm bg-background/80 px-1.5 font-mono text-[10px] font-medium flex",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "text-xs",
                                                children: "⌘"
                                            }),
                                            "K"
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Separator, {}),
                        navigationItems.length > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "py-4 px-4",
                                    children: [
                                        /*#__PURE__*/ _jsx("h3", {
                                            className: "mb-2 text-sm font-medium text-muted-foreground",
                                            children: "Navigation"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex flex-col gap-1",
                                            children: navigationItems.map((item)=>{
                                                var _item_link;
                                                return /*#__PURE__*/ _jsx(NavLink, {
                                                    to: (_item_link = item.link) !== null && _item_link !== void 0 ? _item_link : item.path,
                                                    onClick: ()=>onOpenChange(false),
                                                    activeProps: {
                                                        className: 'bg-accent font-medium'
                                                    },
                                                    className: "rounded-md px-3 py-2 text-sm transition-colors hover:bg-accent",
                                                    children: item.title
                                                }, item.id);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Separator, {})
                            ]
                        }),
                        userApi && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "py-4 px-4",
                                    children: [
                                        /*#__PURE__*/ _jsx("h3", {
                                            className: "mb-2 text-sm font-medium text-muted-foreground",
                                            children: "Account"
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mb-4 rounded-md bg-muted p-3",
                                            children: [
                                                /*#__PURE__*/ _jsx("p", {
                                                    className: "font-medium text-sm",
                                                    children: userApi.name
                                                }),
                                                /*#__PURE__*/ _jsx("p", {
                                                    className: "text-xs text-muted-foreground",
                                                    children: userApi.email
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex flex-col gap-1",
                                            children: userMenuItems.map((item)=>/*#__PURE__*/ _jsxs(Link, {
                                                    to: item.href,
                                                    onClick: ()=>{
                                                        onOpenChange(false);
                                                    },
                                                    className: "flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-colors hover:bg-accent",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(item.icon, {
                                                            className: "h-4 w-4"
                                                        }),
                                                        item.label
                                                    ]
                                                }, item.label))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Separator, {})
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "py-4 px-4",
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "mb-2 text-sm font-medium text-muted-foreground",
                                    children: "Help"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex flex-col gap-1",
                                    children: [
                                        /*#__PURE__*/ _jsxs("a", {
                                            href: links.doc,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: "flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-colors hover:bg-accent",
                                            children: [
                                                /*#__PURE__*/ _jsx(FileText, {
                                                    className: "h-4 w-4"
                                                }),
                                                "Documentation"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("a", {
                                            href: links.support,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: "flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-colors hover:bg-accent",
                                            children: [
                                                /*#__PURE__*/ _jsx(Mail, {
                                                    className: "h-4 w-4"
                                                }),
                                                "Email Support"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("a", {
                                            href: links.discord,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: "flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-colors hover:bg-accent",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "h-4 w-4",
                                                    children: /*#__PURE__*/ _jsx(DiscordIcon, {})
                                                }),
                                                "Discord"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        userApi && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Separator, {}),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "py-4 px-4",
                                    children: /*#__PURE__*/ _jsxs(Button, {
                                        variant: "outline",
                                        className: "w-full justify-start gap-2",
                                        onClick: ()=>void handleLogout(),
                                        children: [
                                            /*#__PURE__*/ _jsx(LogOut, {
                                                className: "h-4 w-4"
                                            }),
                                            "Sign Out"
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
export function MobileMenuTrigger(param) {
    let { onClick } = param;
    return /*#__PURE__*/ _jsxs(Button, {
        variant: "ghost",
        size: "icon",
        onClick: onClick,
        className: "flex items-center justify-center",
        "aria-label": "Open menu",
        children: [
            /*#__PURE__*/ _jsx(Menu, {
                className: "h-5 w-5"
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "sr-only",
                children: "Open menu"
            })
        ]
    });
}
